;(function () {
  'use strict'

  angular
    .module('contrast.filtering')
    .constant('SUBFILTERS', {
      APPS: {
        SUPERADMIN: {
          LIST: ['licenses', 'languages', 'technologies', 'organizations'],
          ENUM: {
            LICENSES: 'licenses',
            LANGUAGES: 'languages',
            TECHNOLOGIES: 'technologies',
            ORGS: 'organizations'
          },
          REQUEST_MAPPING: {
            licenses: 'filterLicenses',
            languages: 'filterLanguages',
            technologies: 'filterTechs',
            organizations: 'filterOrganizations'
          }
        },
        ORG: {
          LIST: ['tags', 'languages', 'technologies', 'servers', 'compliance'],
          ENUM: {
            TAGS: 'tags',
            LANGUAGES: 'languages',
            TECHNOLOGIES: 'technologies',
            SERVERS: 'servers',
            COMPLIANCE: 'compliance'
          },
          REQUEST_MAPPING: {
            tags: 'filterTags',
            languages: 'filterLanguages',
            technologies: 'filterTechs',
            servers: 'filterServers',
            compliance: 'filterCompliance'
          }
        }
      },
      ATTACKS: {
        LIST: [
          'tags',
          'status',
          'rules',
          'applications',
          'application_importances',
          'attackers',
          'servers',
          'server_environments',
          'severities'
        ],
        ENUM: {
          TAGS: 'tags',
          STATUS: 'status',
          RULES: 'rules',
          APPLICATIONS: 'applications',
          APPLICATION_IMPORTANCE: 'application_importances',
          ATTACKERS: 'attackers',
          SERVERS: 'servers',
          SERVER_ENVIRONMENT: 'server_environments',
          SEVERITIES: 'severities'
        },
        REQUEST_MAPPING: {
          tags: 'tags',
          status: 'statusFilter',
          rules: 'protectionRules',
          applications: 'applications',
          application_importances: 'applicationImportances',
          attackers: 'attackers',
          servers: 'servers',
          server_environments: 'serverEnvironments',
          severities: 'severities'
        }
      },
      EVENTS: {
        LIST: [
          'tags',
          'severities',
          'results',
          'rules',
          'applications',
          'servers',
          'environments',
          'attackers'
        ],
        ENUM: {
          TAGS: 'tags',
          SEVERITIES: 'severities',
          RESULTS: 'results',
          RULES: 'rules',
          APPLICATIONS: 'applications',
          SERVERS: 'servers',
          ENVIRONMENTS: 'environments',
          ATTACKERS: 'attackers'
        },
        REQUEST_MAPPING: {
          tags: 'tags',
          severities: 'severities',
          results: 'results',
          rules: 'rules',
          applications: 'applications',
          servers: 'servers',
          environments: 'environments',
          attackers: 'attackers'
        }
      },
      LIBRARIES: {
        ORG: {
          LIST: ['tags', 'languages', 'licenses', 'apps', 'servers'],
          ENUM: {
            TAGS: 'tags',
            LANGUAGES: 'languages',
            LICENSES: 'licenses',
            APPS: 'apps',
            SERVERS: 'servers'
          }
        },
        APP: {
          LIST: ['tags', 'servers', 'licenses'],
          ENUM: {
            TAGS: 'tags',
            SERVERS: 'servers',
            LICENSES: 'licenses'
          }
        },
        SERVER: {
          LIST: ['tags', 'apps', 'licenses'],
          ENUM: {
            TAGS: 'tags',
            APPS: 'apps',
            LICENSES: 'licenses'
          }
        }
      },
      SERVERS: {
        LIST: ['tags', 'loglevels', 'apps', 'agentversion', 'environment'],
        ENUM: {
          TAGS: 'tags',
          LOG_LEVELS: 'loglevels',
          APPS: 'apps',
          AGENT_VERSION: 'agentversion',
          ENVIRONMENTS: 'environment'
        },
        REQUEST_MAPPING: {
          tags: 'tags',
          loglevels: 'logLevels',
          apps: 'applicationsIds',
          agentversion: 'agentVersions',
          environment: 'serverEnvironments'
        }
      },
      VULNS: {
        ORGANIZATION: [
          'tags',
          'severity',
          'status',
          'vulntype',
          'servers',
          'servers-environment',
          'url',
          'route-coverage',
          'modules',
          'security-standard'
        ],
        APPLICATION: [
          'tags',
          'severity',
          'status',
          'vulntype',
          'appversiontags',
          'servers',
          'servers-environment',
          'url',
          'route-coverage',
          'modules',
          'security-standard'
        ],
        SERVER: [
          'tags',
          'severity',
          'status',
          'vulntype',
          'url',
          'route-coverage',
          'modules',
          'security-standard'
        ],
        REQUEST_MAPPING: {
          tags: 'filterTags',
          severity: 'severities',
          status: 'status',
          vulntype: 'vulnTypes',
          appversiontags: 'appVersionTags',
          servers: 'servers',
          'servers-environment': 'environments',
          url: 'urls',
          'route-coverage': 'routes',
          modules: 'modules',
          'security-standard': 'securityStandards'
        },
        ENUM: {
          TAGS: 'tags',
          SEVERITY: 'severity',
          STATUS: 'status',
          VULNTYPE: 'vulntype',
          APP_VERSION_TAGS: 'appversiontags',
          SERVERS: 'servers',
          SERVER_ENVIRONMENT: 'servers-environment',
          URL: 'url',
          MODULES: 'modules',
          SECURITY_STANDARD: 'security-standard'
        }
      }
    })
    .constant('SELECTED_SUBFILTERS_MAP', {
      agentVersions: ['agentversion'],
      applicationImportances: ['application_importances'],
      applications: ['applications'],
      applicationsIds: ['apps'],
      apps: ['apps'],
      appVersionTags: ['appversiontags'],
      attackers: ['attackers'],
      environments: ['environments', 'servers-environment'],
      filterCompliance: ['compliance'],
      filterLanguages: ['languages'],
      filterLicenses: ['licenses'],
      filterOrganizations: ['organizations'],
      filterServers: ['servers'],
      filterTags: ['tags'],
      filterTechs: ['technologies'],
      languages: ['languages'],
      logLevels: ['loglevels'],
      modules: ['modules'],
      protectionRules: ['rules'],
      securityStandards: ['security-standard'],
      serverEnvironments: ['environment', 'server_environments'],
      servers: ['servers'],
      severities: ['severities', 'severity'],
      status: ['status'],
      statusFilter: ['status'],
      tags: ['tags'],
      results: ['results'],
      rules: ['rules'],
      urls: ['url'],
      routes: ['route-coverage'],
      vulnTypes: ['vulntype']
    })
    .constant('DEFAULT_SHOW_LIMIT', 15)
})()
